import { getUser } from "$lib/userstorage/usersotrage";
import { handleAuthenticatedRequest, jsonOrThrow } from "../errores/erroresback"
let ruta_java = import.meta.env.VITE_RUTA_JAVA_SERVER;
let ruta_local_java = import.meta.env.VITE_RUTA_LOCAL_JAVA_SERVER;
let bd_local = import.meta.env.VITE_LOCAL_BD == "si";
let RUTA_JAVA = bd_local ? ruta_local_java : ruta_java
const RUTA_MOVEMENTS = "movements";
export function getMovementType() {
    return [
        { cod: 0, id: "LOT", nombre: "Lote Destino" },
        { cod: 0, id: "HERD", nombre: "Rodeo Destino" },
        { cod: 0, id: "ESTABLISHMENT", nombre: "Transferencia" },
        { cod: 1, id: "CATEGORY", nombre: "Cambio de categoría" },
        { cod: 1, id: "DOWN_DEATH", nombre: "Baja por fallecimiento" },
        { cod: 1, id: "DOWN_SALE", nombre: "Baja por venta" },
        { cod: 0, id: "TRANSFER", nombre: "Transferencia" }
    ];
}
// Para el filtro por tipo: ESTABLISHMENT (transferencia entre establecimientos
// propios, vía "Nuevo movimiento > Transferir") y TRANSFER (transferencias
// históricas migradas desde la entidad Transfer) son dos tipos de movimiento
// distintos en el backend, pero ambos se muestran como "Transferencia" al
// usuario. Sin agrupar, el <select> del filtro los listaba dos veces.
export function getMovementTypeFilterOptions() {
    const tipos = getMovementType();
    const vistos = new Set();
    return tipos.filter(t => {
        if (vistos.has(t.nombre)) return false;
        vistos.add(t.nombre);
        return true;
    });
}
export function getNombreTipo(id) {
    let tipos = getMovementType()
    let t_idx = tipos.findIndex(t => t.id == id)
    if (t_idx != -1) {
        return tipos[t_idx].nombre
    }
    return ""
}
function processMove(move) {
    const animalIds = move.animalIds && move.animalIds.length > 0
        ? move.animalIds
        : (move.animalId ? [move.animalId] : []);
    const animalTagNumbers = move.animalTagNumbers && move.animalTagNumbers.length > 0
        ? move.animalTagNumbers
        : (move.animalTagNumber ? [move.animalTagNumber] : []);

    let data_movimiento = {
        id: move.movementId,
        animal: move.animalId,
        animalnombre: animalTagNumbers.length === 1 ? animalTagNumbers[0] : `${animalTagNumbers.length} animales`,
        animalIds,
        animalTagNumbers,
        cab: move.establishmentId,
        fecha: move.movementDate,
        tipo: move.movementType,
        tiponombre: getNombreTipo(move.movementType),
        fromLotId: move.fromLotId,
        toLotId: move.toLotId,
        fromHerdId: move.fromHerdId,
        toHerdId: move.toHerdId,
        fromEstablishmentId: move.fromEstablishmentId,
        toEstablishmentId: move.toEstablishmentId,
        toCategoryId: move.toCategoryId,
        observaciones: move.notes,
        active: move.isActive,
        // Solo tiene valor real cuando tipo === "TRANSFER" (ver FP-08): false
        // si la transferencia ya fue aceptada (no se puede eliminar), true si
        // sigue pendiente o fue rechazada (sí se puede). null para el resto
        // de los tipos de movimiento.
        transferDeletable: move.transferDeletable ?? null,
    }
    return data_movimiento;
}
function processMoves(data) {
    let data_moves = []
    for (let i = 0; i < data.length; i++) {
        let fila = data[i]
        if (fila.isActive) {
            data_moves.push(processMove(fila))
        }

    }

    return data_moves
}
export async function getAllAnimal(animalId, cabid = null) {

    let user = getUser();
    let token = user.token;

    let ruta = `${RUTA_JAVA}${RUTA_MOVEMENTS}/all`
    let url = new URL(ruta)
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    if (animalId) {
        url.searchParams.append('animalId', animalId);
    }
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await handleAuthenticatedRequest(url.toString(), options)

    let data_all = await jsonOrThrow(res_all, "movimientos.getAllAnimal")

    //data_all = data_all.filter(a=>a.animalId==animalId)

    let procesada = processMoves(data_all)

    return procesada
}
export async function getAll(cabid = null) {
    let user = getUser();
    let token = user.token;

    let ruta = `${RUTA_JAVA}${RUTA_MOVEMENTS}/all`
    let url = new URL(ruta)
    if (cabid) {
        url.searchParams.append('establishmentId', cabid);
    }
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await handleAuthenticatedRequest(url.toString(), options)

    let data_all = await jsonOrThrow(res_all, "movimientos.getAll")


    let procesada = processMoves(data_all)

    return procesada
}
export async function getMoveId(id) {
    let ruta = `${RUTA_JAVA}${RUTA_MOVEMENTS}/${id}`

    let user = getUser();
    let token = user.token;
    let options = {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }
    let res_all = await fetch(ruta, options)
    let data_all = await res_all.json()
    let procesada = processMove(data_all)
    return procesada
}
function postData(data, establishmentId = 1) {
    let data_move = {
        animalIds: data.animales,
        establishmentId: data.cab,
        movementDate: data.fecha,
        movementType: data.tipo,
        fromLotId: data.fromLotId,
        toLotId: data.toLotId,
        fromHerdId: data.fromHerdId,
        toHerdId: data.toHerdId,
        fromEstablishmentId: data.fromEstablishmentId,
        toEstablishmentId: data.toEstablishmentId,
        notes: data.observaciones

    }
    return data_move
}
export async function saveMove(data, establishmentId = 1) {
    let ruta = `${RUTA_JAVA}${RUTA_MOVEMENTS}`
    let user = getUser();
    let token = user.token;
    let res_save = await fetch(ruta, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    });
    if (!res_save.ok) {
        const err = await res_save.json().catch(() => ({}));
        throw new Error(err.message || `Error ${res_save.status}`);
    }
    let data_save = await res_save.json();
    return Array.isArray(data_save) ? data_save.map(processMove) : processMove(data_save);
}
export async function updateMove(id, data) {
    let ruta = `${RUTA_JAVA}${RUTA_MOVEMENTS}/${id}`;
    let user = getUser();
    let token = user.token;
    let res = await fetch(ruta, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.message || `Error ${res.status}`);
    }
    return processMove(await res.json());
}
export async function eliminarMove(id) {
    let ruta = `${RUTA_JAVA}${RUTA_MOVEMENTS}/delete/${id}`
    let user = getUser();
    let token = user.token;
    let res_post = await fetch(ruta,
        {
            method: "POST",
            //            body: JSON.stringify({}), // data can be `string` or {object}!
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
        }
    )

    //let data_post = await res_post.json()
    return {}
}